// Keeps a page's selected tab in the URL query (`?tab=delivered`), so a
// reload lands on the same tab, a copied link opens it, and back/forward
// step between tabs the way they step between pages.
//
// The route is the only copy of the selection. `activeTab` reads it every
// time; `selectTab` pushes a new query and lets the route change flow back
// in. A missing or unknown value falls back to the first tab rather than
// showing nothing, so an old bookmark to /billing or a typo in the query
// both still open a working page.
//
// push, not replace: each tab choice is a history entry, which is what
// makes back/forward walk the tabs. Other query keys are carried over
// untouched.

export function tabQueryMixin(tabIds, param = 'tab') {
  if (!Array.isArray(tabIds) || tabIds.length === 0) {
    throw new Error('tabQueryMixin needs at least one tab id');
  }
  return {
    computed: {
      activeTab() {
        const query = (this.$route && this.$route.query) || {};
        const value = query[param];
        return tabIds.includes(value) ? value : tabIds[0];
      },
    },
    methods: {
      selectTab(id) {
        if (!tabIds.includes(id) || id === this.activeTab) return undefined;
        const route = this.$route || {};
        const query = { ...(route.query || {}), [param]: id };
        const location = { query };
        if (route.path) location.path = route.path;
        if (route.hash) location.hash = route.hash;
        return this.$router.push(location);
      },
    },
  };
}
